<template>
  <div id="app">
    <router-view />
    <notifications
      position="top center"
      :duration="4000"
      :width="320"
      classes="vue-notification kt-notify"
    />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>
